import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Settings, Globe, Languages, Layout } from "lucide-react";

export const Route = createFileRoute("/admin/settings")({
  component: SettingsPage,
});

function SettingsPage() {
  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <Settings className="h-5 w-5" /> Paramètres
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Établissement · Tenant · i18n · Densité</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2"><Globe className="h-4 w-4" /> Établissement</CardTitle>
            <CardDescription>Tenant · Site principal</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <div>
              <label className="text-xs">Nom</label>
              <Input defaultValue="Clinique Medigroup Casablanca" />
            </div>
            <div>
              <label className="text-xs">N° Établissement (CNSS)</label>
              <Input defaultValue="1234567890" />
            </div>
            <Button>Enregistrer</Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2"><Languages className="h-4 w-4" /> Localisation</CardTitle>
            <CardDescription>i18n, RTL, densité</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3 text-sm text-muted-foreground">
            Langues supportées : FR · AR (RTL) · EN
            <br />Densité : compact / comfortable / spacious
            <br />Fuseau : Africa/Casablanca
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
